import { cloneDeep } from 'lodash-es';
import { useEffect, useState } from 'react';

import { Button, DescriptionBar, Grid, SearchBar } from 'components';

import DeleteModal from './DeleteModal';

import { ContactProfileGridData, ContactProfileDetailData } from './types';
import { manageGridColumns } from './utils';

import { PlusOutlineIcon } from 'assets/svgs';
import RegisterModal from './RegisterModal';
import axios from 'common/AxiosAuth';
import ContactProfileModal from './ContactProfileModal';

import { useTranslation } from 'react-i18next';
import { useIsMobile } from 'hooks/useIsMobile';
import { convertAltitudeToKmString } from 'utils';


const ContactProfile = () => {
  const [searchValue, setSearchValue] = useState<string>('');
  const [checkedRows, setCheckedRows] = useState<number[]>([]);
  const [modalData, setModalData] = useState<ContactProfileDetailData | null>(null);
  const [deleteModalData, setDeleteModalData] = useState<ContactProfileGridData[] | null>(null);
  const [isRegisterModalOpened, setIsRegisterModalOpened] = useState<boolean>(false);
  const [contactProfileData, setContactProfileData] = useState<ContactProfileGridData[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const pageSize = 10; // 페이징처리 기준
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  useEffect(() => {
    if (searchValue.trim() ==='') {
      getContactProfile(currentPage);
    } else {
      seachContactProfile(searchValue, currentPage);
    }
  }, [currentPage, searchValue]);

    useEffect(() => {
    setCurrentPage(1);
  }, [searchValue]);

  const seachContactProfile = async(query: string, pageNum: number) => {
    try{
      const res = await axios.get('/api/contactprofile/search', {
          params: {
          keyword: query,
          page: pageNum - 1, // 0-based
          size: pageSize,
          sort: 'createdDate,DESC',
        },
      });
  const { content = [], totalElements = 0 } = res.data;
  const contactProfileGridData: ContactProfileGridData[] = content.map((item: any) => ({
      name: item.name,
      groundStationName: item.groundStationName,
      city: item.groundStationCity,
      minimumContactDuration: item.minContactDuration,
      minimumDegrees: item.minElevationDegrees,
      registeredAt: item.createdDate,
      contactProfileId: item.contactProfileId
    }));


      setContactProfileData(contactProfileGridData);
      setTotalPages(Math.ceil(totalElements / pageSize));
    } catch(error) {
      console.error('검색 실패', error);
    }
  };
  console.log('Grid Row', contactProfileData[0]);

  const getContactProfile = async (pageNum: number) => {
    //ConactProfile 데이터 호출
    const res = await axios.get(`/api/contactprofile/page/${pageNum}?pageSize=${pageSize}`);
    const { contactProfileList = [], totalElement = 0 } = res.data;
    console.log('contactProfileList', contactProfileList);
    const contactProfileGridData = contactProfileList.map((item: ContactProfileGridData) => {
      return {
        ...item,
        groundStationName: item.groundStationDto?.name,
        name: item.name,
        city: item.groundStationDto?.city,
        minimumContactDuration: item.minContactDuration,
        minimumDegrees: item.minElevationDegrees,
        registeredAt: item.createdDate, 
        altitudeMeters: item.altitudeMeters,
        latitudeDegrees: item.latitudeDegrees,
        longitudeDegrees: item.longitudeDegrees,
        statusName: item.statusName,
        providerName: item.providerName
      };
    });
    console.log('contactProfileGridData',contactProfileGridData);
    setContactProfileData(contactProfileGridData);
    // 총 페이지 수 계산
    const totalPages = Math.ceil(totalElement / pageSize);
    setTotalPages(totalPages);
  };

  async function onClickDetail(data: ContactProfileGridData) {
    const res = await axios.get(`/api/contactprofile/${data.contactProfileId}`);
    const resData = res.data;
    console.log('resData', resData);
    const location =
      `LAT : ${resData.groundStationDto.latitudeDegrees}, ` +
      ` LNG : ${resData.groundStationDto.longitudeDegrees}, ` +
      `ALT : ${resData.groundStationDto.altitudeMeters} m`;
    const temp: ContactProfileDetailData = {
      //여기 수정 원래는 resData.id
      contactProfileId: resData.contactProfileId,
      groundStationDto: resData.groundStationDto,
      name: resData.name,
      minElevationDegrees: resData.minElevationDegrees,
      minContactDuration: resData.minContactDuration,
      registeredAt: resData.groundStationDto.createdDate,
      createdDate: resData.createDate,
      altitudeMeters: resData.groundStationDto.altitudeMeters,
      latitudeDegrees: resData.groundStationDto.latitudeDegrees,
      longitudeDegrees: resData.groundStationDto.longitudeDegrees,
      city: resData.groundStationDto.city,
      statusName: resData.groundStationDto.statusName,
      providerName: resData.groundStationDto.providerName,
      groundStationName: resData.groundStationDto.name,
      location: location
    };
    setModalData(temp);
  }

  function onClickDelete() {
    setDeleteModalData(checkedRows.map((rowIndex) => contactProfileData[rowIndex]));
  }

  function onClickAddSpacecraft() {
    setIsRegisterModalOpened(true);
  }

  function onClickDeleteInDetailModal() {
    const data = cloneDeep(modalData);
    setModalData(null);
  }
  
  return (
    <>
      <div className="flex h-full w-full flex-col">
        <DescriptionBar
          className="md:px-6"
          title={t('contactProfile.pageTitle')}
          description={t('contactProfile.pageDescription')}
        />
        <div className="flex flex-row flex-wrap items-center justify-between gap-4 p-6">
          <SearchBar className="w-full md:w-60" value={searchValue} setValue={setSearchValue} placeholder="Search" />
          <div className="flex w-full flex-row justify-between gap-2 md:w-fit">
            <Button
              className="h-8"
              type="secondary"
              text={t('contactProfile.button.delete')}
              onClick={onClickDelete}
              disabled={!checkedRows.length}
              aria-label="delete a contact profile"
            />
            <Button
              className="h-8"
              type="blue"
              text={t('contactProfile.button.add')}
              onClick={onClickAddSpacecraft}
              icon={<PlusOutlineIcon className="[&_path]:stroke-white" />}
              aria-label="register a contact profile"
            />
          </div>
        </div>
        <Grid
          className="max-w-full overflow-y-auto"
          gridColumns={ 
            (isMobile
            ? manageGridColumns.filter(col => col.showOnMobile)
            : manageGridColumns
            ).map(col => ({
            ...col,
            width: isMobile ? undefined : col.width,  
            }))
          }
          gridData={contactProfileData}
          searchValue={searchValue}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          options={{
            useFilter: false,
            useSearch: {
              use: true,
              searchKeys: ['name', 'groundStationName', 'minContactDuration', 'minElevationDegrees', 'city']
            },
            useCheckbox: true,
            useSort: {
              use: true,
              sortKeys: ['name', 'groundStationName', 'minContactDuration', 'minElevationDegrees', 'createdDate','city']
            },
            usePagination: {
              use: true,
              maxPage: totalPages
            },
            customCell: {
              minContactDuration: (_, row, index) => (
                <span>{(row as ContactProfileDetailData).minContactDuration + 'sec'}</span>
              ),
              minElevationDegrees: (_, row, index) => (
                <span>{(row as ContactProfileDetailData).minElevationDegrees + 'º'}</span>
              ),
              viewDetails: (_, row, index) => (
                <Button
                  text="View Details"
                  type="secondary"
                  size="small"
                  onClick={() => onClickDetail(row as ContactProfileDetailData)}
                />
              )
            }
          }}
          checkedRows={checkedRows}
          setCheckedRows={setCheckedRows}
        />
      </div>
      <ContactProfileModal data={modalData} setData={setModalData} onDelete={onClickDeleteInDetailModal} onContactProfileUpdated={()=>getContactProfile(currentPage)}/>
      <RegisterModal
        isOpened={isRegisterModalOpened}
        setIsOpened={setIsRegisterModalOpened}
        onContactProfileUpdated={()=>getContactProfile(currentPage)}
      />
      <DeleteModal data={deleteModalData} setData={setDeleteModalData} onDeleted={()=>getContactProfile(currentPage)} setCheckedRows={setCheckedRows}/>
    </>
  );
};

export default ContactProfile;
